<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Permiso' : 'Crear Nuevo Permiso' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <form [formGroup]="permissionForm" (ngSubmit)="onSubmit()">
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Id del Permiso</mat-label>
            <input matInput formControlName="id" placeholder="Ej: users.create, reporting.*, *.*" class="text-lg text-white bg-blue-primary" cdkFocusInitial>
            <mat-error *ngIf="idControl?.invalid && (idControl?.dirty || idControl?.touched)">
                <span *ngIf="idControl?.errors?.['required']">El id es requerido.</span>
                <span *ngIf="idControl?.errors?.['invalidPermissionId']">El formato del id no es válido. Ej: users.read, billing.*, *.*</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Nombre del Permiso</mat-label>
            <input matInput formControlName="name" placeholder="Ej: Crear usuarios" class="text-lg text-white bg-blue-primary">
            <mat-error  *ngIf="nameControl?.invalid && (nameControl?.dirty || nameControl?.touched)">
                <span *ngIf="nameControl?.errors?.['required']">El nombre es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Descripción</mat-label>
            <textarea matInput formControlName="description" placeholder="Descripción detallada del permiso" class="text-lg text-white bg-blue-primary"></textarea>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Grupo</mat-label>
            <input matInput formControlName="group" placeholder="Ej: Usuarios, Contabilidad" class="text-lg text-white bg-blue-primary">
        </mat-form-field>
        <mat-slide-toggle formControlName="active" class="mb-4">
            Activo
        </mat-slide-toggle>
        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>
    </form>
</mat-dialog-content>
